import axios from 'axios'
import store from '../store'
import moment from 'moment'

export const apiResource = axios.create({
  headers: { Pragma: 'no-cache' },
  baseURL: process.env.VUE_APP_API_URL
})

apiResource.interceptors.request.use((config) => {
  let originalRequest = config
  if (store.getters.authenticated && config.url.search('api/refresh') === -1) {
    return store.dispatch('refreshUserToken').then((response) => {
      return Promise.resolve(originalRequest)
    }, (error) => {
      if (moment().add(1, 'hours') <= moment(store.getters.token_expires)) {
        store.commit('setMessage', { type: 'error', text: 'error.generic.1', translate: true })
        window._paq.push(['trackEvent', 'Login', 'Session End', 'Session Timeout'])
      }
      store.dispatch('logout')
      return Promise.reject(error)
    })
  }
  return config
}, (error) => {
  store.commit('setError', error)
  store.commit('setLoading', false)
  return Promise.reject(error)
})

